import { v4 as uuid } from 'uuid'
import { useAtomValue } from 'jotai'
import { FC, useMemo, useState } from 'react'
import { amOwnershipRootEntitySchema } from 'src/common-services'
import { DataGrid } from 'src/v2/components/data-grid'
import * as atoms from 'src/v2/state/owner-reveal'
import * as entityRootsAtoms from 'src/v2/state/owner-reveal/entity-roots'
import { ROWS_PER_TABLE_PAGE } from 'src/v2/views/owner-reveal/insights/owner-contacts/constants'
import styled from '@emotion/styled'
import { InsightEmpty } from 'src/views/insight-empty'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 196px);
  position: relative;
`

const RootEntitiesInner: FC = () => {
  const selectedEntityId = useAtomValue(atoms.selectedEntityId)
  const entities = useAtomValue(entityRootsAtoms.rootEntities(selectedEntityId))
  const [page, setPage] = useState(1)

  const rows = useMemo(() => {
    if (!entities) {
      return []
    }
    return entities.slice((page - 1) * ROWS_PER_TABLE_PAGE, page * ROWS_PER_TABLE_PAGE)
  }, [entities, page])

  const pagesCount = useMemo(() => Math.ceil(entities.length / ROWS_PER_TABLE_PAGE), [])

  return (
    <Container>
      <DataGrid
        disableVirtualization
        columns={Object.keys(amOwnershipRootEntitySchema.shape).map((field) => ({
          field,
          headerName: field,
        }))}
        getRowId={(row) => row.am_unique_provider_entity_id ?? uuid()}
        rows={rows}
        rowHeight={40}
        disableColumnFilter
        disableRowSelectionOnClick
        pagination
        page={page}
        paginationCount={pagesCount}
        onPageChange={setPage}
      />
    </Container>
  )
}

export const RootEntitiesTable: FC = () => {
  const selectedEntityId = useAtomValue(atoms.selectedEntityId)
  const entities = useAtomValue(entityRootsAtoms.rootEntities(selectedEntityId))

  if (entities.length === 0) {
    return (
      <InsightEmpty
        message="It looks like we don't have entity data for this Owner yet. We're constantly gathering new data, so keep an
          eye out for updates."
      />
    )
  }

  return <RootEntitiesInner />
}
